import { useState, useEffect } from 'react';
import { feedbackApi } from '../../api/feedback.api';
import { PageHeader, Skeleton, EmptyState } from '../../components/ui/index';
import { toPersian } from '../../utils/persianNumber';
import { RatingStars, FeedbackHeroLogo } from '../../components/feedback/FeedbackMoodPicker';

export default function MyFeedbackInfoPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    feedbackApi.getMyFeedbackSummary().then(r=>setData(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);
  return (
    <div className="fade-in">
      <PageHeader title="بازخوردهای من"/>
      {loading?<Skeleton h={200} radius={14}/>
      :!data?<EmptyState icon={<FeedbackHeroLogo size={48} />} title="بازخوردی ثبت نشده"/>
      :<div style={{maxWidth:560,background:'#fff',borderRadius:16,border:'1px solid rgba(59,130,246,0.1)',padding:28}}>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:16,marginBottom:24}}>
            {[['میانگین',data.avg_rating||0,'avg'],['تعداد',data.count||0,'count'],['آخرین',data.last_rating||0,'last']].map(([lbl,val,kind])=>(
              <div key={lbl} style={{textAlign:'center',padding:16,background:'#f8faff',borderRadius:12}}>
                <div style={{display:'flex',justifyContent:'center',marginBottom:6}}>
                  {kind==='count'
                    ? <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 19V5M4 19h16M8 16V9M12 16V7M16 16v-4" stroke="#233afa" strokeWidth="2" strokeLinecap="round"/></svg>
                    : <RatingStars value={val} size={14} />}
                </div>
                <div style={{fontSize:22,fontWeight:800,color:'#2563eb',marginTop:4}}>{toPersian(val)}</div>
                <div style={{fontSize:11,color:'#94a3b8'}}>{lbl}</div>
              </div>
            ))}
          </div>
          {data.comments&&data.comments.map((c,i)=>(
            <div key={i} style={{padding:'12px 0',borderBottom:'1px solid #f1f5f9',fontSize:13,color:'#334155'}}>
              <div style={{display:'flex',gap:4,marginBottom:6}}><RatingStars value={c.rating} size={15} /></div>
              {c.comment}
            </div>
          ))}
        </div>
      }
    </div>
  );
}